import { render, staticRenderFns } from "./PostProduction.vue?vue&type=template&id=74a2906a&scoped=true&"
import script from "./PostProduction.vue?vue&type=script&lang=js&"
export * from "./PostProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a2906a",
  null
  
)

export default component.exports